<div class="info-group-container" [class.info-open]="isOpen">

    <div class="tabs-container" *ngIf="location">

        <div class="main-tab" [ngSwitch]="location.type" [class.selected]="location.type === activeTab" (click)="tabClicked(location.type)" role="button"  tabindex="-1">

            <ng-container *ngSwitchCase="'vehicle'">
                {{'general.dashboard-map.infoPanel.vehicle' | translate}}
            </ng-container>

            <ng-container *ngSwitchCase="'case'">
                {{'general.dashboard-map.infoPanel.case' | translate}}
            </ng-container>

            <ng-container *ngSwitchCase="'appointment'">
                {{'general.dashboard-map.infoPanel.res' | translate}}
            </ng-container>

            <ng-container *ngSwitchCase="'org'">
                {{'general.dashboard-map.infoPanel.org' | translate}}
            </ng-container>

        </div>

        <div class="relation-tabs">
            <div class="regular-tab" *ngFor="let tab of secondaryTabs" [ngSwitch]="tab" [class.selected]="tab === activeTab" (click)="tabClicked(tab)" role="button"  tabindex="-1">
                <ng-container *ngSwitchCase="'vehicle'">
                    {{'general.dashboard-map.infoPanel.vehicle' | translate}}
                </ng-container>

                <ng-container *ngSwitchCase="'case'">
                    {{'general.dashboard-map.infoPanel.case' | translate}}
                </ng-container>

                <ng-container *ngSwitchCase="'appointment'">
                    {{'general.dashboard-map.infoPanel.res' | translate}}
                </ng-container>

                <ng-container *ngSwitchCase="'org'">
                    {{'general.dashboard-map.infoPanel.org' | translate}}
                </ng-container>

                <ng-container *ngSwitchDefault>
                    {{('general.dashboard-map.infoPanel.vehicle' | translate) +' '+ tab}}
                </ng-container>
            </div>

            <div class="regular-tab close-panel-button" (click)="close()" role="button"  tabindex="-1">X</div>
        </div>

    </div>

    <div class="main-info-displayer" [ngSwitch]="activeTab" *ngIf="!loading; else panelLoading">

            <ng-container *ngSwitchCase="'vehicle'">

                <div class="info-line">
                    <span class="info-title">
                        {{'general.dashboard-map.infoPanel.labels.vehicleNo' | translate}}
                    </span>
                    {{allData.vehicle.vehicleNo}}
                </div>

                <div class="info-line">
                    <span class="info-title">
                        {{'general.dashboard-map.infoPanel.labels.licensePlate' | translate}}
                    </span>
                    {{allData.vehicle.licensePlate}}
                </div>

                <div class="info-line">
                    <span class="info-title">
                        {{'general.dashboard-map.infoPanel.labels.mobileType' | translate}}
                    </span>
                    {{allData.vehicle.mobileStatus?.satatus}}
                </div>

                <div class="info-line" *ngIf="allData.vehicle.mobileStatus?.sla">
                    <span class="info-title" [style.color]="isSlaNegative ? '#fb7c46' : 'inherit'">
                        {{'general.dashboard-map.infoPanel.labels.sla' | translate}}
                    </span>
                    <i *ngIf="isSlaNegative" class="fa-solid fa-triangle-exclamation" style="color: #fb7c46;font-size: 1.3rem;"></i>
                    <span [style.color]="isSlaNegative ? '#fb7c46' : 'inherit'">{{timeDisplay}}</span>
                </div>

                <div class="info-line">
                    <span class="info-title">
                        {{'general.dashboard-map.infoPanel.labels.vehicleType' | translate}}
                    </span>
                    {{allData.vehicle.vehicleType}}
                </div>

                <div class="info-line">
                    <span class="info-title">
                        {{'general.dashboard-map.infoPanel.labels.dotName' | translate}}
                    </span>
                    {{allData.vehicle.dot?.dotName}}
                </div>

                <div class="info-line personel-button">
                    <button class="btn btn-success" style="width: 100%;" (click)="checkStaff(allData.vehicle)">
                        {{ 'general.dashboard-map.infoPanel.labels.showPersonel' | translate }}
                        <i class="fa fa-users ms-2"></i>
                    </button>
                </div>

                <!--Mobiliz Alanları-->
                <ng-container *ngIf="allData.vehicle.mobiliz">
                    <div class="info-line-divider">Mobiliz</div>


                    <div class="accordion accordion-no-gutter accordion-bordered" id="accordion-mobiliz">
                        <div class="accordion-item" *ngFor="let tab of ['main', 'status', 'location', 'gpsData']">
                            <button
                                type="button"
                                class="accordion-header collapsed rounded-lg w-100 text-start"
                                [id]="'accord-' + tab"
                                data-bs-toggle="collapse"
                                [attr.data-bs-target]="'#collapse' + tab"
                                [attr.aria-controls]="'collapse' + tab"
                                aria-expanded="true"
                                >
                            <span class="accordion-header-text">{{tab}}</span>
                            <span class="accordion-header-indicator"></span>
                            </button>
                            <div [id]="'collapse'+tab" class="collapse accordion__body" [attr.aria-labelledby]="'accord-'+tab" data-bs-parent="#accordion-mobiliz">
                            <div class="accordion-body-text">
                                <div class="info-line" *ngFor="let line of allData.vehicle.mobiliz[tab] | keyvalue">
                                    <span class="info-title">
                                        {{line.key}}
                                    </span>
                                    {{line.value}}
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>



                </ng-container>


            </ng-container>

            <ng-container *ngSwitchCase="'case'">

                <div class="info-line">
                    <a class="info-title" [routerLink]="['/case/'+allData.case.id,{fullscreen:true,case:true}]">
                        {{'general.dashboard-map.infoPanel.labels.protocolNo' | translate}}
                    </a>
                    {{allData.case.protocolNo}}
                </div>

                <div class="info-line">
                    <span class="info-title">
                        {{'general.dashboard-map.infoPanel.labels.caseType' | translate}}
                    </span>
                    {{allData.case.caseType}}
                </div>

                <div class="info-line">
                    <span class="info-title">
                        {{'general.dashboard-map.infoPanel.labels.caseDate' | translate}}
                    </span>
                    {{allData.case.caseDate | date: 'dd.mm.yyyy HH:ss'}}
                </div>

                <!--Hasta Bilgileri-->
                <app-patient-info-card *ngIf="allData.case.patient" [patient]="allData.case.patient"></app-patient-info-card>

                <!--Alınan Adres-->
                <div class="info-line" *ngIf="allData.case.pickup && (allData.case.pickup.institution || allData.case.pickup.address)">
                    <span class="info-title">
                        {{'general.dashboard-map.infoPanel.labels.fromAddress' | translate}}
                    </span>
                </div>

                <div class="info-line" *ngIf="allData.case.pickup.institution">
                    <span>
                        <i class="fa-solid fa-building"></i>
                        {{allData.case.pickup.institution}}
                    </span>
                </div>

                <div class="info-line" *ngIf="allData.case.pickup.address">
                    {{allData.case.pickup.address}}
                </div>

                <!--Bırakılan Adres-->
                <div class="info-line" *ngIf="allData.case.drop && (allData.case.drop.institution || allData.case.drop.address)">
                    <span class="info-title">
                        {{'general.dashboard-map.infoPanel.labels.toAddress' | translate}}
                    </span>
                </div>

                <div class="info-line" *ngIf="allData.case.drop.institution">
                    <span>
                        <i class="fa-solid fa-building"></i>
                        {{allData.case.drop.institution}}
                    </span>
                </div>

                <div class="info-line" *ngIf="allData.case.drop.address">
                    {{allData.case.drop.address}}
                </div>


            </ng-container>

            <ng-container *ngSwitchCase="'appointment'">

                <div class="info-line">
                    <span class="info-title">
                        {{'general.dashboard-map.infoPanel.labels.protocolNo' | translate}}
                    </span>
                    {{allData.appointment.protocolNo}}
                </div>

                <div class="info-line">
                    <span class="info-title">
                        {{'general.dashboard-map.infoPanel.labels.caseType' | translate}}
                    </span>
                    {{allData.appointment.caseType}}
                </div>

                <div class="info-line">
                    <span class="info-title">
                        {{'general.dashboard-map.infoPanel.labels.resDate' | translate}}
                    </span>
                    {{allData.appointment.appointmentStartDate | date: 'dd.mm.yyyy HH:ss'}}
                </div>

                <!--Hasta Bilgileri-->
                <app-patient-info-card *ngIf="allData.appointment.patient" [patient]="allData.appointment.patient"></app-patient-info-card>

                <!--Alınan Adres-->
                <div class="info-line" *ngIf="allData.appointment.pickup && (allData.appointment.pickup.institution || allData.appointment.pickup.address)">
                    <span class="info-title">
                        {{'general.dashboard-map.infoPanel.labels.fromAddress' | translate}}
                    </span>
                </div>

                <div class="info-line" *ngIf="allData.appointment.pickup.institution">
                    <span>
                        <i class="fa-solid fa-building"></i>
                        {{allData.appointment.pickup.institution}}
                    </span>
                </div>

                <div class="info-line" *ngIf="allData.appointment.pickup.address">
                    {{allData.appointment.pickup.address}}
                </div>

                <!--Bırakılan Adres-->
                <div class="info-line" *ngIf="allData.appointment.drop && (allData.appointment.drop.institution || allData.appointment.drop.address)">
                    <span class="info-title">
                        {{'general.dashboard-map.infoPanel.labels.toAddress' | translate}}
                    </span>
                </div>

                <div class="info-line" *ngIf="allData.appointment.drop.institution">
                    <span>
                        <i class="fa-solid fa-building"></i>
                        {{allData.appointment.drop.institution}}
                    </span>
                </div>

                <div class="info-line" *ngIf="allData.appointment.drop.address">
                    {{allData.appointment.drop.address}}
                </div>


            </ng-container>

            <ng-container *ngSwitchCase="'org'">

                <div class="info-line">
                    <span class="info-title">
                        {{'general.dashboard-map.infoPanel.labels.orgNo' | translate}}
                    </span>
                    {{allData.org.protocolNo}}
                </div>

                <div class="info-line">
                    <span class="info-title">
                        {{'general.dashboard-map.infoPanel.labels.orgName' | translate}}
                    </span>
                    {{allData.org.name}}
                </div>

                <div class="info-line">
                    <span class="info-title">
                        {{'general.dashboard-map.infoPanel.labels.orgDate' | translate}}
                    </span>
                    {{allData.org.startDate | date: 'dd.mm.yyyy'}}
                    <!-- {{allData.org.startTime}} -->
                </div>

                <div class="info-line">
                    <span class="info-title">
                        {{'general.dashboard-map.infoPanel.labels.authorizedPerson' | translate}}
                    </span>
                    {{allData.org.authorizedPerson}}
                </div>

                <div class="info-line">
                    <span class="info-title">
                        {{'general.dashboard-map.infoPanel.labels.authorizedPhone' | translate}}
                    </span>
                    <div *ngIf="allData.org.authorizedPhone" style="display: flex;align-items: center;gap: 6px;">
                        {{allData.org.authorizedPhone}}
                        <app-call-button  [class]="'btn btn-success p-1 pt-0 pb-0'" [phone]="allData.org.authorizedPhone"></app-call-button>
                    </div>
                </div>

            </ng-container>

            <ng-container *ngIf="activeCaseVehicle >= 0">

                <div class="info-line">
                    <span class="info-title">
                        {{'general.dashboard-map.infoPanel.labels.vehicleNo' | translate}}
                    </span>
                    {{allData.caseVehicles[activeCaseVehicle].vehicleNo}}
                </div>

                <div class="info-line">
                    <span class="info-title">
                        {{'general.dashboard-map.infoPanel.labels.licensePlate' | translate}}
                    </span>
                    {{allData.caseVehicles[activeCaseVehicle].licensePlate}}
                </div>

                <div class="info-line">
                    <span class="info-title">
                        {{'general.dashboard-map.infoPanel.labels.mobileType' | translate}}
                    </span>
                    {{allData.caseVehicles[activeCaseVehicle].mobileStatus?.satatus}}
                </div>

                <div class="info-line" *ngIf="allData.caseVehicles[activeCaseVehicle].mobileStatus?.sla">
                    <span class="info-title" [style.color]="isSlaNegative ? '#fb7c46' : 'inherit'">
                        {{'general.dashboard-map.infoPanel.labels.sla' | translate}}
                    </span>
                    <i *ngIf="isSlaNegative" class="fa-solid fa-triangle-exclamation" style="color: #fb7c46;font-size: 1.3rem;"></i>
                    <span [style.color]="isSlaNegative ? '#fb7c46' : 'inherit'">{{timeDisplay}}</span>
                </div>

                <div class="info-line">
                    <span class="info-title">
                        {{'general.dashboard-map.infoPanel.labels.vehicleType' | translate}}
                    </span>
                    {{allData.caseVehicles[activeCaseVehicle].vehicleType}}
                </div>

                <div class="info-line">
                    <span class="info-title">
                        {{'general.dashboard-map.infoPanel.labels.dotName' | translate}}
                    </span>
                    {{allData.caseVehicles[activeCaseVehicle].dot?.dotName}}
                </div>

                <div class="info-line personel-button">
                    <button class="btn btn-success" style="width: 100%;" (click)="checkStaff(allData.caseVehicles[activeCaseVehicle])">
                        {{ 'general.dashboard-map.infoPanel.labels.showPersonel' | translate }}
                        <i class="fa fa-users ms-2"></i>
                    </button>
                </div>

                <!--Mobiliz Alanları-->
                <ng-container *ngIf="allData.caseVehicles[activeCaseVehicle].mobiliz">
                    <div class="info-line-divider">Mobiliz</div>


                    <div class="accordion accordion-no-gutter accordion-bordered">
                        <div class="accordion-item" *ngFor="let tab of ['main', 'status', 'location', 'gpsData']">
                            <button
                                type="button"
                                class="accordion-header collapsed rounded-lg w-100 text-start"
                                [id]="'accord-' + tab"
                                data-bs-toggle="collapse"
                                [attr.data-bs-target]="'#collapse' + tab"
                                [attr.aria-controls]="'collapse' + tab"
                                aria-expanded="true"
                                >
                            <span class="accordion-header-text">{{tab}}</span>
                            <span class="accordion-header-indicator"></span>
                            </button>
                            <div [id]="'collapse'+tab" class="collapse accordion__body" [attr.aria-labelledby]="'accord-'+tab" data-bs-parent="#accordion-mobiliz">
                            <div class="accordion-body-text">
                                <div class="info-line" *ngFor="let line of allData.caseVehicles[activeCaseVehicle].mobiliz[tab] | keyvalue">
                                    <span class="info-title">
                                        {{line.key}}
                                    </span>
                                    {{line.value}}
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>



                </ng-container>


            </ng-container>

    </div>

    <ng-template #panelLoading>
        <div class="main-info-displayer">
            <div class="search-spinner">
                <i class="fa fa-spinner fa-spin"></i>
            </div>
        </div>
    </ng-template>

    <div *ngIf="lastUpdate" class="date-info-panel">
        {{('general.dashboard-map.lastUpdateText' | translate)+': '+(lastUpdate | date:'HH:mm:ss')}}
    </div>

</div>
